import React, { useEffect, useState } from "react";
import { Group, Image as KonvaImage } from "react-konva";

interface ErrorIconKonvaProps {
  icon: string;
  width?: number;
  height?: number;
  x?: number;
  y?: number;
}

export const ErrorIconKonva = React.memo((props: ErrorIconKonvaProps) => {
  const { width = 44, height = 26, icon, ...otherProps } = props;
  const [image, setImage] = useState<HTMLImageElement | null>(null);

  useEffect(() => {
    const img = new Image();
    const blob = new Blob([icon], { type: "image/svg+xml" });
    const url = URL.createObjectURL(blob);
    img.src = url;
    img.addEventListener("load", () => {
      setImage(img);
    });

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [icon]);

  if (!image) {
    return null;
  }

  return (
    <Group {...otherProps} listening={false}>
      <KonvaImage image={image} width={width} height={height} />
    </Group>
  );
});

ErrorIconKonva.displayName = "ErrorIconKonva";
